import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { localize } from 'helpers/translator'

import iconClose from 'assets/global/global_close.svg'

import styles from './media_preview.scss'

class MediaPreview extends PureComponent {

	blockedMedia = (thumbnail, message) => (
		<div styleName='blocked-slide' style={{backgroundImage: `url(${thumbnail})`}}>
			<p styleName='blocked-slide-text'>{message}</p>
		</div>
	)

	audio = () => (
		<Fragment>
			{
				this.props.shouldBlockMedia ?
					this.blockedMedia(this.props.mediaVersions.flash, localize('cacophony_audio_paused'))
					:
					<audio styleName='audio' controls='true'>
						<source src={this.props.mediaVersions.mp3} type="audio/mpeg" />
						<source src={this.props.mediaVersions.ogg} type="audio/ogg" />
					</audio>
			}
		</Fragment>
	)

	video = () => (
		<Fragment>
			{
				this.props.shouldBlockMedia ?
					this.blockedMedia(this.props.mediaVersions.flash, localize('cacophony_video_paused'))
					:
					<video styleName='video' controls='true'>
						<source src={this.props.mediaVersions.webm} type="video/webm" />
						<source src={this.props.mediaVersions.ipad} type="video/mp4" />
					</video>
			}
		</Fragment>
	)

	youtube = () => (
		<Fragment>
			{
				this.props.shouldBlockMedia ?
					this.blockedMedia(this.props.mediaVersions.flash, localize('cacophony_video_paused'))
					:
					<iframe
						wmode='opaque'
						frameBorder='0'
						allowFullScreen
						src={this.props.mediaVersions.link}
						styleName='video'
					/>
			}
		</Fragment>
	)

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='veil' onClick={this.props.onClose}></div>
				<div styleName={classNames({
					container: true,
					'container-image': this.props.mediaType === 'image',
				})}>
					<div styleName='close-button' onClick={this.props.onClose}>
						<img src={iconClose} />
					</div>
					{ this.props.mediaType === 'image' &&
						<img styleName='image' src={this.props.mediaVersions.flash} />
					}
					{ (this.props.mediaType === 'audio' ||
						// TODO: Remove after removing audio-recorder-oeq,
						// audio-recorder-drawit, audio-recorder-quiz, audio-recorder-poll FF
						this.props.mediaType === 'audio_recorder') &&
						this.audio()
					}
					{ this.props.mediaType === 'video' &&
						this.video()
					}
					{ this.props.mediaType === 'youtube' &&
						this.youtube()
					}
				</div>
			</div>
		)
	}
}

MediaPreview.propTypes = {
	shouldBlockMedia: PropTypes.bool,
	mediaType: PropTypes.string,
	mediaVersions: PropTypes.object,
	onClose: PropTypes.func,
}

MediaPreview.defaultProps = {
	shouldBlockMedia: false,
}

export default CSSModules(MediaPreview, styles, {allowMultiple: true})
